// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a8f1c21a","455":"74350d34","977":"b4753cde"}[chunkId] + ".chunk.js";
};